import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, MapPin, Phone } from "lucide-react";
import { LOGO_URL, NAV_LINKS } from "@/lib/constants";

const TRUST_LINKS = [
    { name: "Methodology", path: "/methodology" },
    { name: "Security & Data Governance", path: "/security" },
    { name: "Resources", path: "/resources" },
    { name: "Contact", path: "/contact" }
];

export default function Footer() {
    return (
        <footer className="relative border-t border-navy/10 bg-paper mt-24" data-testid="site-footer">
            <div className="max-w-[1500px] mx-auto px-6 lg:px-10 pt-24 pb-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                        <div className="mb-8">
                            <img
                                src={LOGO_URL}
                                alt="Carbonis"
                                className="h-24 w-auto"
                            />
                        </div>
                        <p className="font-serif text-3xl lg:text-4xl leading-[1.05] text-navy/90 max-w-[520px]">
                            We move climate from <em className="text-gold">reporting</em> to <em className="text-gold">risk control.</em>
                        </p>
                        <div className="mt-10 flex items-center gap-4">
                            <Link to="/contact" className="btn-institution" data-testid="footer-cta">
                                Book a Briefing <ArrowUpRight size={14} />
                            </Link>
                        </div>
                    </div>

                    <div className="lg:col-span-2">
                        <div className="font-mono text-[10px] tracking-[0.25em] text-navy/40 uppercase mb-6">Navigation</div>
                        <ul className="space-y-3">
                            {NAV_LINKS.map((l) => (
                                <li key={l.path}>
                                    {l.external ? (
                                        <a
                                            href={l.path}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-navy/70 hover:text-gold transition-colors duration-300 text-sm inline-flex items-center gap-1"
                                        >
                                            {l.name}
                                            <ArrowUpRight size={12} strokeWidth={1.5} />
                                        </a>
                                    ) : (
                                        <Link to={l.path} className="text-navy/70 hover:text-gold transition-colors duration-300 text-sm">
                                            {l.name}
                                        </Link>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="font-mono text-[10px] tracking-[0.25em] text-navy/40 uppercase mb-6">Trust & Governance</div>
                        <ul className="space-y-3">
                            {TRUST_LINKS.map((l) => (
                                <li key={l.path}>
                                    <Link
                                        to={l.path}
                                        className="text-navy/70 hover:text-gold transition-colors duration-300 text-sm"
                                        data-testid={`footer-trust-${l.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                                    >
                                        {l.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="font-mono text-[10px] tracking-[0.25em] text-navy/40 uppercase mb-6">Contact</div>
                        <ul className="space-y-4 text-sm">
                            <li className="flex items-start gap-3 text-navy/80">
                                <MapPin size={16} strokeWidth={1.5} className="mt-0.5 text-gold shrink-0" />
                                <span>Hyderabad, India<br/>An UP/OR/OUT Company</span>
                            </li>
                            <li className="flex items-center gap-3 text-navy/80">
                                <Mail size={16} strokeWidth={1.5} className="text-gold" />
                                <a href="mailto:info@carbonis.in" className="hover:text-gold transition-colors">info@carbonis.in</a>
                            </li>
                            <li className="flex items-center gap-3 text-navy/80">
                                <Phone size={16} strokeWidth={1.5} className="text-gold" />
                                <a href="tel:+919515727578" className="hover:text-gold transition-colors">+91 95157 27578</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="hairline mt-20"></div>

                <div className="mt-8 flex flex-col md:flex-row justify-between gap-4 text-xs font-mono uppercase tracking-[0.2em] text-navy/40">
                    <div>© {new Date().getFullYear()} Carbonis by UP/OR/OUT. All rights reserved.</div>
                    <div className="flex gap-6">
                        <span>Aligned · RBI · SEBI · CBAM · ISO 14064 · GHG Protocol</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
